import { ProductScreenshot } from 'components/ProductScreenshot';
import EventsInPostHogLight from "../../../../contents/images/tutorials/android-analytics/events-light.png";
import EventsInPostHogDark from "../../../../contents/images/tutorials/android-analytics/events-dark.png";
import IdentifyLight from "../../../../contents/images/tutorials/android-analytics/identify-light.png";
import IdentifyDark from "../../../../contents/images/tutorials/android-analytics/identify-dark.png";
import InsightLight from "../../../../contents/images/tutorials/android-analytics/create-insights-light.png";
import InsightsDark from "../../../../contents/images/tutorials/android-analytics/create-insights-dark.png";
import * as React from 'react';
export default {
  ProductScreenshot,
  EventsInPostHogLight,
  EventsInPostHogDark,
  IdentifyLight,
  IdentifyDark,
  InsightLight,
  InsightsDark,
  React
};